import { memo } from 'react'
import debugWrapper from '../utils/debugWrapper'

/**
 * Reusable loading spinner component
 * Eliminates duplicate loading states across the app
 * 
 * @param {string} size - Size variant: 'sm', 'md', 'lg' (default: 'md')
 * @param {string} message - Optional loading message
 * @param {boolean} centered - Whether to center in container (default: true)
 * @param {string} color - Border color class (default: 'border-primary')
 */
const LoadingSpinner = memo(function LoadingSpinner({ size = 'md', message, centered = true, color = 'border-primary' }) {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-b-2'
  }

  const spinnerClass = `animate-spin rounded-full ${sizeClasses[size]} ${color}`

  const spinner = (
    <>
      <div className={spinnerClass}></div>
      {message && (
        <p className="mt-2 text-gray-600 text-sm">{message}</p>
      )}
    </>
  )

  if (centered) {
    return (
      <div className="flex flex-col items-center justify-center py-8">
        {spinner}
      </div>
    )
  }

  return (
    <div className="inline-flex items-center gap-2">
      {spinner}
    </div>
  )
})

export default debugWrapper(LoadingSpinner, 'LoadingSpinner', 'src/components/LoadingSpinner.jsx')
